<script setup lang="ts">
import type { ButtonSize } from '@global-types/buttonSize.ts';
import type { ButtonVariant } from '@global-types/buttonVariant.ts';
import { defineProps, computed } from 'vue';

const props = defineProps<{
  variant?: ButtonVariant,
  size?: ButtonSize,
}>();

const classes = computed<string[]>(() => {
  const classList = [];
  if (props.variant) {
    classList.push(`btn--${props.variant}`);
  }

  if (props.size) {
    classList.push(`btn--${props.size}`);
  }

  return classList;
});
</script>

<template>
  <button
    class="btn"
    :class="classes"
  >
    <slot />
  </button>
</template>
